export default __webpack_public_path__ + "static/linkBg3-1ed758e039c056cc024165dcf694020c.png";